export const transformWidgetTableData = (data, backData) => {
  return data.map(item => {
    const provider = item?.id === "provider" ? backData.host : "";

    return {
      ...item,
      value: provider ? provider : backData[item.id],
    };
  });
};
